import React from "react";
import clockIcon from "../../../files/icons/clockIcon.png";
import locationIcon from "../../../files/icons/locationIcon.png";
import phoneIcon from "../../../files/icons/phoneIcon.png";
import pdfIcon from "../../../files/icons/pdfIcon.png";
import destination from "../../../files/images/dest.jpg";
import mailIcon from "../../../files/icons/mailIcon.png";
import rekvizit from "../../../files/documents/rekvizit.pdf";
import styles from "./contacts.module.css";

class ContactsSlide extends React.Component {
  render() {
    return (
      <div style={{ display: "flex", height: "42.3em" }}>
        <div
          className={styles.boxFlex}
          style={{
            flex: "12",
            borderRadius: "6px 6px 6px 6px",
            backgroundColor: "white"
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "6px 6px 0px 0px"
            }}
          >
            <div
              style={{
                padding: "0.5em",
                backgroundColor: "#bbc9d6",
                color: "white",
                borderRadius: "6px 6px 0px 0px"
              }}
            >
              <span style={{ paddingLeft: "1em", fontSize: "1vw" }}>
                КОНТАКТЫ
              </span>
            </div>
            <div
              className={styles.line}
              style={{
                display: "flex",
                alignItems: "center",
                paddingTop: "0.55em",
                paddingBottom: "0.55em"
              }}
            >
              <div style={{ flex: "1", textAlign: "center" }}>
                <img
                  src={phoneIcon}
                  style={{ width: "1.3em", height: "1.3em" }}
                />
              </div>
              <div className={styles.header} style={{ flex: "12" }}>
                <div>+7(925)365-59-14</div>
                <div>+7(495)672-72-13</div>
              </div>
            </div>
            <div
              style={{
                marginLeft: "1.5em",
                marginRight: "1.2em",
                borderTop: "1px solid #eef4f6"
              }}
            />
            <div
              className={styles.line}
              style={{
                display: "flex",
                alignItems: "center",
                paddingTop: "0.55em",
                paddingBottom: "0.55em"
              }}
            >
              <div style={{ flex: "1", textAlign: "center" }}>
                <img
                  src={locationIcon}
                  style={{ width: "1.3em", height: "1.3em" }}
                />
              </div>
              <div style={{ flex: "12" }}>
                <div style={{ fontWeight: "600" }}>Наш адрес:</div>
                <div>111524, г.Москва, ул.Электродная, дом 10, офис 67</div>
              </div>
            </div>
            <div
              style={{
                marginLeft: "1.5em",
                marginRight: "1.2em",
                borderTop: "1px solid #eef4f6"
              }}
            />
            <div
              className={styles.line}
              style={{
                display: "flex",
                alignItems: "center",
                paddingTop: "0.55em",
                paddingBottom: "0.55em"
              }}
            >
              <div style={{ flex: "1", textAlign: "center" }}>
                <img
                  src={clockIcon}
                  style={{ width: "1.3em", height: "1.3em" }}
                />
              </div>
              <div style={{ flex: "12" }}>
                <div style={{ fontWeight: "600" }}>Время работы:</div>
                <div>пн-пт: с 9:00 до 18:00</div>
              </div>
            </div>
            <div
              style={{
                borderTop: "1px solid #eef4f6"
              }}
            />
            <div
              style={{
                paddingLeft: "1.5em",
                paddingTop: "1.1em",
                paddingBottom: "0.55em"
              }}
              className={styles.header}
            >
              ПОДКЛЮЧЕНИЕ И ПУСКО-НАЛАДОЧНЫЕ РАБОТЫ
            </div>

            <div
              className={styles.line}
              style={{
                display: "flex",
                alignItems: "baseline",
                paddingBottom: "0.55em"
              }}
            >
              <div style={{ flex: "1", textAlign: "center" }}>
                <img
                  src={phoneIcon}
                  style={{ width: "1.3em", height: "1.3em" }}
                />
              </div>
              <div style={{ flex: "12" }}>
                <div className={styles.header}>+7-926-213-14-47</div>
                <div>Шамурин Виталий Владимирович</div>
                <div>
                  <a href="v.shamurin@teplo-inform.ru">
                    v.shamurin@teplo-inform.ru
                  </a>
                </div>
              </div>
            </div>

            <div
              style={{
                borderTop: "1px solid #eef4f6"
              }}
            />

            <div
              style={{
                paddingLeft: "1em",
                paddingTop: "1.1em",
                paddingBottom: "0.55em"
              }}
            >
              <div style={{ display: "flex" }}>
                <div style={{ flex: "1", textAlign: "center" }}>
                  <img
                    src={mailIcon}
                    style={{ width: "1.3em", height: "1.3em" }}
                  />
                </div>
                <div style={{ flex: "12" }} className={styles.header}>
                  ДОГОВОРНОЙ ОТДЕЛ
                </div>
              </div>

              <div style={{ display: "flex" }}>
                <div style={{ flex: "1" }} />
                <div style={{ flex: "12" }}>
                  <div>Мукубенова Кермен Викторовна</div>
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div style={{ flex: "1" }} />
                <div style={{ flex: "12" }}>
                  <a href="buh@teplo-inform.ru">buh@teplo-inform.ru</a>
                </div>
              </div>
            </div>

            <div
              style={{
                paddingLeft: "1em",
                paddingTop: "1.1em",
                paddingBottom: "0.55em"
              }}
            >
              <div style={{ display: "flex" }}>
                <div style={{ flex: "1", textAlign: "center" }}>
                  <img
                    src={mailIcon}
                    style={{ width: "1.3em", height: "1.3em" }}
                  />
                </div>
                <div style={{ flex: "12" }} className={styles.header}>
                  ГЕНЕРАЛЬНЫЙ ДИРЕКТОР
                </div>
              </div>

              <div style={{ display: "flex" }}>
                <div style={{ flex: "1" }} />
                <div style={{ flex: "12" }}>
                  <div>Хильковский Константин Борисович</div>
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div style={{ flex: "1" }} />
                <div style={{ flex: "12" }}>
                  <a href="gendir@teplo-inform.ru">gendir@teplo-inform.ru</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ flex: "1" }} />
        <div
          className={styles.boxFlex}
          style={{
            flex: "12",
            borderRadius: "6px 6px 6px 6px",
            backgroundColor: "white"
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "6px 6px 6px 6px"
            }}
          >
            <div
              style={{
                padding: "1.3em",
                borderBottom: "1px solid #eef4f6",
                borderRadius: "6px 6px 0px 0px"
              }}
            >
              <img src={pdfIcon} style={{ width: "1.8em", height: "2.1em" }} />
              <a
                href={rekvizit}
                download='Реквизиты ООО "Теплоинформ"'
                target="_blank"
                rel="noopener noreferrer"
                style={{ fontSize: "1vw", paddingLeft: "0.3vw" }}
              >
                Реквизиты ООО "Теплоинформ"
              </a>
            </div>
            <div
              style={{
                paddingLeft: "1.3em",
                fontWeight: "600",
                paddingBottom: "1.9em",
                paddingTop: "1.9em"
              }}
            >
              <div>КАК ДОБРАТЬСЯ ОТ СТАНЦИИ МЕТРО</div>
              <div>«ШОССЕ ЭНТУЗИАСТОВ»:</div>
            </div>
            <div style={{ textAlign: "center" }}>
              <img
                src={destination}
                style={{
                  width: "100%",
                  height: "31em",
                  borderRadius: "6px 6px 6px 6px"
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ContactsSlide;
